<template>
  <el-dialog
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :before-close="cancel"
    title="词库list"
    append-to-body
    width="585px"
  >
    <el-table
      v-if="tableData !== null"
      :data="tableData"
      style="width: 100%; margin-bottom: 20px"
      row-key="tmpId"
      size="small"
      default-expand-all
      :tree-props="{ children: 'children' }"
    >
      <el-table-column prop="name">
        <template slot-scope="scope">
          <span
            v-if="scope.row.type === 1"
            style="font-weight: 700; font-size: 14px"
            >{{ scope.row.name }}</span
          >
          <span v-else-if="scope.row.type === 2" style="font-weight: 700">{{
            scope.row.name
          }}</span>
          <span v-else>{{ scope.row.name }}</span>
        </template> </el-table-column
      >>
      <el-table-column label="操作" width="130px" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="copy(scope.row)"
            v-if="scope.row.type === 4 && isHave(scope.row.id)"
            >选择</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="cancelCopy(scope.row)"
            v-if="scope.row.type === 4 && !isHave(scope.row.id)"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">取消</el-button>
      <el-button type="primary" @click="enter">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getPracticeMenus } from "@/api/practiceMenus";
export default {
  data() {
    return {
      num:1,
      loading: false,
      dialog: false,
      tableData: null,
      delLoading: false,
      selectId: [],
    };
  },
  watch: {
    dialog: function (e, r) {
      if (e === true) {
        this.getPracticeMenusFn();
        this.isHave()
      }
    },
  },
  methods: {
    isHave(id) {
      for (let i in this.selectId) {
        if (+id === +this.selectId[i].id) {
          return false;
        }
      }
      return true;
    },
        cancelCopy(e) {
      //取消
      for (let i in this.selectId) {
        if (+e.id === +this.selectId[i].id) {
          this.selectId.splice(i, 1);
          return;
        }
      }
    },
    getPracticeMenusFn() {
      //获取树
      getPracticeMenus().then((e) => {
        this.tableData = e.content;
      });
    },
    cancel() {
      this.resetForm();
    },
    enter() {
      this.$emit("copyOver", this.selectId);
      this.dialog = false;
      this.selectId = []
    },
    copy(e) {
      //选择
      console.log(e);
      if(this.selectId.length!=0){
        let pid=this.selectId[0].pid
        console.log(pid);
        console.log(e.pid);
        if(pid===e.pid){
          this.selectId.push({ id: e.id, name: e.name,pid:e.pid});
        }else{
          this.$message({
            message: "请添加同一个词库里的list",
            type: "error"
          });
          return;
        }
      }else{
        this.selectId.push({ id: e.id, name: e.name ,pid:e.pid});
      }
      
    },

    resetForm() {
      this.dialog = false;
    },
  },
  beforeMount() {},
};
</script>

<style scoped>
</style>
